import { faFacebook, faInstagram, faLinkedin, faTiktok, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cloneElement } from "react";

const socialMediaIconMap: Record<string, JSX.Element> = {
  facebook: <FontAwesomeIcon icon={faFacebook} />,
  instagram: <FontAwesomeIcon icon={faInstagram} />,
  linkedin: <FontAwesomeIcon icon={faLinkedin} />,
  tiktok: <FontAwesomeIcon icon={faTiktok} />,
  x: <FontAwesomeIcon icon={faXTwitter} />,
};

interface SocialMediaIconProps {
  title: string;
  color?: string;
  fontSize?: string;
}

export default function SocialMediaIcons(props: SocialMediaIconProps) {
  const { title, ...rest } = props;
  const name = title.toLowerCase();
  const socialIcon = socialMediaIconMap[name] || null;

  return socialIcon ? cloneElement(socialIcon, { ...rest }) : null;
}
